import OpenAI from 'openai';

const API_KEY = process.env.REACT_APP_OPENAI_API_KEY;
const MODEL = process.env.REACT_APP_OPENAI_MODEL || 'gpt-4o-mini';

const openai = API_KEY ? new OpenAI({
    apiKey: API_KEY,
    dangerouslyAllowBrowser: true // Required for client-side usage
}) : null;

export const getOpenAIResponse = async (prompt, history = [], systemInstruction = "") => {
    if (!openai) {
        return "API key missing. Please set REACT_APP_OPENAI_API_KEY in your .env file.";
    }

    try {
        const messages = [
            { role: "system", content: systemInstruction },
            ...history.map(msg => ({
                role: msg.isBot ? "assistant" : "user",
                content: msg.text
            })),
            { role: "user", content: prompt }
        ];

        const completion = await openai.chat.completions.create({
            model: MODEL,
            messages,
        });

        return completion.choices?.[0]?.message?.content || 'I could not generate a response right now.';
    } catch (error) {
        console.error('OpenAI error:', error);

        if (error?.status === 404 || error?.message?.includes('deprecated')) {
            return 'The configured AI model is no longer supported. Please update REACT_APP_OPENAI_MODEL to a supported model such as gpt-4o-mini.';
        }

        return `Error: ${error?.message || 'Unknown error occurred while generating the response.'}`;
    }
};
